// Translations
import form from '../sections/form/translations/ru'

// Translation: Two-factor authentication > Landing (Russian)
export default Object.freeze({
	sections: { form }
})
